import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-link',
    templateUrl: 'detail-link.component.html',
    styleUrls: ['./detail-link.component.scss'],
    standalone: true,
})
export class DetailMapItemLinkComponent {
    @Input({ required: true })
    public label?: string;

    @Output()
    public readonly mapItemLinkClicked = new EventEmitter<void>();

    public triggerMapItem(event: Event): void {
        // Keep a keydown event from triggering a closing of the detail window.
        event.preventDefault();

        this.mapItemLinkClicked.emit();
    }
}
